export default function PreviewGallery({ config }) {
  const g = config?.website?.gallery || {};
  const images = (g.images || []).filter((x) => x.enabled);

  return (
    <section style={{ padding: "0 24px 26px" }}>
      <div
        style={{
          borderRadius: "var(--ns-radius-lg)",
          background: "var(--ns-card)",
          border: "1px solid var(--ns-card-border)",
          boxShadow: "var(--ns-shadow)",
          padding: 18
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 }}>
          <div>
            <h3 style={{ margin: 0, color: "var(--ns-ink)", fontWeight: 950, fontSize: 18 }}>
              {g.title || "Gallery"}
            </h3>
            {g.subtitle ? (
              <div style={{ marginTop: 6, color: "var(--ns-muted)", fontSize: 13 }}>
                {g.subtitle}
              </div>
            ) : null}
          </div>

          <div
            style={{
              padding: "8px 10px",
              borderRadius: 999,
              background: "rgba(15,23,42,0.04)",
              border: "1px solid rgba(15,23,42,0.08)",
              color: "rgba(11,18,32,0.65)",
              fontSize: 12,
              fontWeight: 900
            }}
          >
            {images.length} photos
          </div>
        </div>

        <div style={{ marginTop: 14 }}>
          {images.length === 0 ? (
            <div style={{ color: "var(--ns-muted)", fontSize: 13 }}>
              Add at least 6 photos (food, ambience, seating, entry, signature dish).
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                gap: 12
              }}
            >
              {images.slice(0, 6).map((img) => (
                <div
                  key={img.id}
                  style={{
                    borderRadius: 16,
                    overflow: "hidden",
                    border: "1px solid rgba(15,23,42,0.10)",
                    background: "rgba(15,23,42,0.03)",
                    height: 170
                  }}
                  title={img.title || ""}
                >
                  <img
                    src={img.key}
                    alt={img.alt || img.title || ""}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
